export interface SelectionConfig {
  allowSelection?: boolean;
  dynamicWidth?: boolean;
  columnWidth?: number;
  maxWidth?: number;
}
